module.exports = __webpack_public_path__ + "static/media/Illus-EmployeeBag.a3cea6e1.png";